/* eslint-disable @typescript-eslint/no-explicit-any */

export function preventMultipleCalls<T extends (...args: any[]) => any>(fn: T): T {
	const cached: Record<string, ReturnType<T>> = {};
	async function cleanup(key: string) {
		try {
			// eslint-disable-next-line @typescript-eslint/await-thenable
			await cached[key];
		} catch {
			delete cached[key];
		} finally {
			delete cached[key];
		}
	}
	return function (...args: Parameters<T>): ReturnType<T> {
		const key = JSON.stringify(args);
		if (key in cached) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			return cached[key];
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const result = fn(...args);
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		cached[key] = result;

		cleanup(key)
			.then(() => ({}))
			.catch(() => {
				// Handle error if needed
			});

		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return result as ReturnType<T>;
	} as T;
}
